export default {
  HARDWARE: "Hardware",
  ADMINISTRATION: "Administration",
  DIGITAL_SALES_TOOLS: "Digital sales tools",
}
